import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Operator } from 'client/voladeum/operators/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: Operator[] = EMPTY_ARRAY;

export const operatorsSlice = createSlice({
  name: SLICE.OPERATORS,
  initialState,
  reducers: {
    setOperators: (_state, action: PayloadAction<Operator[]>) => {
      return action.payload;
    },
    clearOperators: () => {
      return initialState;
    },
  },
});

export const { setOperators, clearOperators } = operatorsSlice.actions;

export default operatorsSlice.reducer;
